module.exports = __webpack_public_path__ + "pcstatic/img/book6.5d4273e.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image2/book6.png
// module id = VEMi
// module chunks = 28